import MenuItemsProperties from "./MenuItemsProperties";
export default MenuItemsProperties